import larsPic from "./images/lars_birkholm_petersen.jpg";
import toddPic from "./images/todd_mitchell.jpg";
import alexPic from "./images/alex_shyba.jpg";

export const altolans = [
    {
        name: 'Lars Petersen',
        profilePic: larsPic,
        specialization: 'Business Optimization, Analytics & Personalization',
        services: 'Digital Experience hackathon, Analytics, Personalization, Quick Wins, Context Marketing'
    },
    {
        name: 'Todd Mitchell',
        profilePic: toddPic,
        specialization: 'experience platform & machine learning',
        services: 'xConnect, Sitecore as a platform'
    },
    {
        name: 'Alex Shyba',
        profilePic: alexPic,
        specialization: 'content management & front-end development',
        services: 'JSS, Headless, Sitecore as a platform'
    },
];



// WEBPACK FOOTER //
// ./src/content/collections/altolans/index.js